var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('img',{staticClass:"mr-2 rounded-circle",attrs:{"src":_vm.imgPath,"width":"60","height":"60"},on:{"click":function($event){$event.stopPropagation();return _vm.showFull.apply(null, arguments)}}}),_c('div',[_vm._v(_vm._s(_vm.data.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }